import type { MockServer } from './server.js'

export const routes = (server: MockServer) => {
  // Reset namespace to handle routes not under /api
  const originalNamespace = server.namespace
  server.namespace = ''

  server.post('/:provet_id/payment_gateway/tenant_token/', () => {
    return {
      access_token: 'mock-token',
      expires_in: 3600,
      token_type: 'Bearer',
      scope: 'all',
      validity: 3600,
    }
  })

  server.get(
    '/:provet_id/payment_gateway/organization_structure/json',
    (): ETrustCompanyWithDepartments[] => {
      return [
        {
          id: 'company-1',
          name: 'Mock Company',
          ern: '123456',
          is_active: true,
          reference: 'REF-1',
          allow_payout: true,
          departments: [
            {
              id: 'dept-1',
              name: 'Mock Department',
              ern: '654321',
              is_active: true,
              allow_processing: true,
              onboarding_status: 'completed',
              reference: 'REF-DEPT-1',
            },
          ],
        },
      ]
    },
  )

  // Restore original namespace
  server.namespace = originalNamespace
}
